import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FacilityInfoService } from '../../common/services/facility-info.service';
import { ProfileBuilderService } from '../../common/services/profile-builder.service';
import * as _ from 'lodash';

import { GaService } from '../../common/services/ga.service';
import { JwtService } from '../../common/services/jwt.service';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'hospital-profile',
  templateUrl: './hospital-profile.component.html',
  styleUrls: ['./hospital-profile.component.css'],
  providers: [FacilityInfoService, ProfileBuilderService, ProfileBuilderService],
})
export class HospitalProfileComponent implements OnInit {
  // Base year for data
  yearData = 2024;

  // id passed as param used to search data
  selectedId: string

  public isGenInfoCollapsed: boolean = false;
  public isCSuiteCollapsed: boolean = false;
  public isFacCodesCollapsed: boolean = true;
  public isApprCodesCollapsed: boolean = false;
  public isAddressCollapsed: boolean = false;
  public isUtilizationCollapsed: boolean = false;
  public isPhyscCodesCollapsed: boolean = false;
  public isAffiliatedCollapsed: boolean = false;
  public isMapCollapsed: boolean = true;
  public isAffiliatedMapCollapsed: boolean = false;
  public collapsedSubsidiaryMap: boolean = true;


  gettingProfile = false;
  isSubsidiary = false;

  facility;
  facilityGeneralInfo;
  facilityLocation;
  facilityIndividuals;
  facilityUtilization;
  facilityCodes;
  facilityApprovalCodes;
  facilityPhysicianCodes;
  facilityUnitsCodes;
  filterProfileBy = 'All Items';
  profileFilters = [];

  // Tableau
  tableauJWT = null
  showInnerHtml: boolean = false;
  showInnerHtmlAffiliates: boolean = false;

  constructor(
    private facilitySearch: FacilityInfoService,
    private profileBuilder: ProfileBuilderService,
    private route: ActivatedRoute,
    private router: Router,
    private gaService: GaService,
    private jwtService: JwtService,
  ) {
    this.selectedId = this.route.snapshot.params['id'];
    this.getProfile(this.selectedId, this.yearData);

    // we subscribe to route params to reload data if id in url changes
    this.route.params.subscribe(params => {
      this.paramsChanged(params['id']);
    });
  }

  ngOnInit(): void {
    this.jwtService.getToken()
      .filter(token => token !== null)
      .subscribe(token => {
        this.tableauJWT = token;
      });
  }

  get tableuSelectedID(): string {
    return "000" + this.selectedId
  }


  updateInnerHTMLToken() {
    if (this.showInnerHtml && this.tableauJWT) {
      const tableauContainer = document.getElementById('tableauContainer');
      if (tableauContainer) {
        tableauContainer.innerHTML = `

        `;
      }
    }
  }

  updateInnerHTMLTokenAffiliates() {
    if (this.showInnerHtmlAffiliates && this.tableauJWT) {
      const tableauContainer = document.getElementById('tableauContainerAffiliates');
      if (tableauContainer) {
        tableauContainer.innerHTML = `

        `;
      }
    }
  }

  getProfile(id, year) {
    this.gettingProfile = true;

    // get facility takes a start and end year, for now we use same start and end
    this.facilitySearch.getFacility(id, year, year).subscribe(
      ({ data }) => {
        this.gettingProfile = false;
        this.facility = data.getFacility;
        this.createDataObjs(this.facility);
      },
      error => {
        this.gettingProfile = false;
        console.error(error, 'Could not get facility data');
      }
    );
  }

  paramsChanged(id) {
    // we only fetch profile if id is different
    if (this.selectedId !== id) {
      this.selectedId = id;
      this.isSubsidiary = false;
      this.getProfile(id, this.yearData);
    }
  }

  backToSearch() {
    this.router.navigate(['searchResults']);
  }

  createDataObjs(facility) {
    if ('parentUnit' in facility) {
      if (facility.parentUnit !== null) {
        this.isSubsidiary = true;
      }
    }

    this.createGenInfoObj(facility);
    this.createLocationObj(facility);
    this.createIndividualsObj(facility);
    this.createUtilizationObj(facility);
    this.createFacilityCodesObj(facility);
    this.createApprovalCodesObj(facility);
    this.createPhysicianCodesObj(facility);
    this.createAffUnitsCodesObj(facility);

    this.checkDropDownFilters();
  }

  checkDropDownFilters() {
    // we have a base Array that holds basic drop down info, we add to this dropdown if we have
    // information to show

    let tempArr = ['All Items', 'General Information', 'Address', 'Map', 'C-Suite'];
    if (!this.isSubsidiary && !_.isEmpty(this.facilityUtilization)) {
      tempArr.push('Utilization');
    }
    if (!this.isSubsidiary && !_.isEmpty(this.facilityApprovalCodes)) {
      tempArr.push('Accreditations and Certifications');
    }
    if (!this.isSubsidiary && !_.isEmpty(this.facilityCodes)) {
      tempArr.push('Facilities and Services');
    }
    if (!this.isSubsidiary && !_.isEmpty(this.facilityUnitsCodes)) {
      tempArr.push('Subsidiary Hospitals');
      tempArr.push('Subsidiary Hospitals Map');
    }
    this.profileFilters = tempArr;
  }

  createGenInfoObj(facility) {
    this.facilityGeneralInfo = this.profileBuilder.createGenInfoObj(facility);
  }

  createLocationObj(facility) {
    this.facilityLocation = this.profileBuilder.createAddressObj(facility);
  }

  createIndividualsObj(facility) {
    this.facilityIndividuals = this.profileBuilder.createCSuiteObj(facility);
  }

  createUtilizationObj(facility) {
    this.facilityUtilization = this.profileBuilder.createUtilizationObj(facility);
  }

  createFacilityCodesObj(facility) {
    this.facilityCodes = this.profileBuilder.createCodesObj(facility, 'facilityCodes');
  }

  createPhysicianCodesObj(facility) {
    this.facilityPhysicianCodes = this.profileBuilder.createCodesObj(facility, 'physicianCodes');
  }

  createApprovalCodesObj(facility) {
    this.facilityApprovalCodes = this.profileBuilder.createCodesObj(facility, 'approvalCodes');
  }

  createAffUnitsCodesObj(facility) {
    this.facilityUnitsCodes = this.profileBuilder.createCodesObj(facility, 'affiliatedUnits');
  }

  toggle(event) {
    event.preventDefault();
    this.filterProfileBy = event.target.innerHTML;

    // google analytics
    this.gaService.addProfileFilterClick(this.filterProfileBy);
  }

  expandAll() {
    this.isGenInfoCollapsed = false;
    this.isCSuiteCollapsed = false;
    this.isFacCodesCollapsed = false;
    this.isApprCodesCollapsed = false;
    this.isAddressCollapsed = false;
    this.isUtilizationCollapsed = false;
    this.isPhyscCodesCollapsed = false;
    this.isAffiliatedCollapsed = false;
    this.isMapCollapsed = false;
    this.collapsedSubsidiaryMap = false;
  }

  collapseAll() {
    this.isGenInfoCollapsed = true;
    this.isCSuiteCollapsed = true;
    this.isFacCodesCollapsed = true;
    this.isApprCodesCollapsed = true;
    this.isAddressCollapsed = true;
    this.isUtilizationCollapsed = true;
    this.isPhyscCodesCollapsed = true;
    this.isAffiliatedCollapsed = true;
    this.isMapCollapsed = true;
    this.collapsedSubsidiaryMap = true;
  }

  getData() {
    this.yearData = 2024;
    this.getProfile(this.selectedId, this.yearData);
  }

  toggleMainMap() {
    this.isMapCollapsed = !this.isMapCollapsed;
    this.showInnerHtml = !this.showInnerHtml;
    if (this.showInnerHtml) {
      //this.updateInnerHTMLToken();
    }
  }

  toggleSubsidiaryMap() {
    this.collapsedSubsidiaryMap = !this.collapsedSubsidiaryMap;
    this.showInnerHtmlAffiliates = !this.showInnerHtmlAffiliates;
    if (this.showInnerHtmlAffiliates) {
      //this.updateInnerHTMLTokenAffiliates();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/hospital-profile/hospital-profile.component.ts